import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import "./PaginatorComponent.scss";

const useStyles = makeStyles((theme) => ({
	root: {
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
	},
}));

const PaginatorComponent = ({
	page: pageParent,
	setPage: setParentPage,
	totalItems,
	itemsToShow,
}) => {
	useStyles();
	const [totalPages, setTotalPages] = useState();
	const [page, setPage] = useState(pageParent);

	useEffect(() => {
		setPage(pageParent);
	}, [pageParent]);

	useEffect(() => {
		setTotalPages(Math.ceil(totalItems / itemsToShow));
	}, [totalItems]);

	const handleChange = (event, value) => {
		setPage(value);
		setParentPage(value);
	};
	return (
		<>
			<Pagination
				className="pagination"
				count={totalPages === 0 ? 1 : totalPages}
				page={page}
				onChange={handleChange}
			/>
		</>
	);
};

export default PaginatorComponent;
